// extracted by mini-css-extract-plugin
export default {"sectionTitle":"section_sectionTitle__JJqiL","sectionContainer":"section_sectionContainer__aFVGC"};